import React from "react";
import NewProductTemplate from "../../components/sections/product-more-info/Item";
import { cn } from "../../utils/cn";
import Emoji from "../../utils/emoji";

const styles = {
    strong: "font-semibold text-ccyan",
    title: "font-bold text-xl font-montserrat",
    list: "list-disc ml-4",
};

const Product = (props) => {
    const { pageContext } = props;
    const { item } = pageContext;

    const Data = () => {
        return (
            <section className="mx-auto max-w-xl text-left font-inter text-gray-500 lg:max-w-2xl xl:max-w-3xl">
                <h2 className="text-2xl font-semibold text-cpurple">
                    <Emoji
                        symbol="💻"
                        label="campus pràctic del bulevard 2026"
                    />{" "}
                    CAMPUS PRÀCTIC DEL BULEVARD — 40a PROMOCIÓ (2026/2027)
                </h2>

                <p className="mt-5">
                    Tot el Bulevard concentrat en un únic campus online.
                </p>

                <p className="mt-5">
                    T&apos;agradaria preparar el Bulevard des de casa, al teu
                    ritme i amb total flexibilitat?
                </p>

                <p className="mt-5">
                    El Campus Pràctic del Bulevard és una formació 100% online,
                    creada perquè puguis començar a preparar aquesta etapa abans
                    d&apos;arribar a l&apos;ISPC, sense dependre d&apos;horaris
                    ni de sessions presencials.
                </p>

                <p className="mt-5">
                    A través del campus virtual tindràs accés a vídeos
                    explicatius, fitxes didàctiques i recursos exclusius que
                    t&apos;ajudaran a entendre els procediments policials i les
                    situacions pràctiques que treballaràs durant la teva
                    formació.
                </p>

                <p className="mt-5">
                    És la manera ideal d&apos;arribar a la 40a promoció amb més
                    coneixements, més confiança i una millor preparació.
                </p>

                <h2 className={cn(styles.title, "mt-10")}>
                    <Emoji symbol="🎯" label="preparacio practica abans ispc" />{" "}
                    Una preparació pràctica abans de l&apos;ISPC
                </h2>

                <p className="mt-5">
                    L&apos;objectiu del campus no és només que memoritzis
                    continguts, sinó que entenguis com s&apos;estructura una
                    intervenció policial i com afrontar diferents situacions des
                    d&apos;un punt de vista pràctic.
                </p>

                <p className="mt-5">
                    A través dels diferents mòduls treballaràs procediments,
                    normativa, mediació, documentació policial i altres aspectes
                    essencials del Bulevard.
                </p>

                <p className="mt-5">
                    Tot el contingut està organitzat de manera progressiva
                    perquè primer consolidis els conceptes i posteriorment els
                    puguis aplicar en situacions reals.
                </p>

                <h2 className={cn(styles.title, "mt-10")}>
                    <Emoji symbol="📚" label="que inclou campus practic" /> Què
                    inclou el campus?
                </h2>

                <p className="mt-5">
                    El campus està format per diferents mòduls que agrupen els
                    continguts principals del Bulevard.
                </p>

                <p className="mt-5">
                    En cada apartat trobaràs vídeos explicatius, fitxes
                    didàctiques i recursos de suport que t&apos;ajudaran a
                    entendre i consolidar la matèria.
                </p>

                <ul className={cn(styles.list, "mt-5")}>
                    <li>Mòdul 0 · Benvinguda i perfil policial.</li>
                    <li>Mòdul 1 · Esquema d&apos;una intervenció policial.</li>
                    <li>Mòdul 2 · Traspàs d&apos;informació i escalada.</li>
                    <li>Mòdul 3 · Identificacions, escorcolls i detenció.</li>
                    <li>Mòdul 4 · Tècniques de mediació.</li>
                    <li>Mòdul 5 · Les diferents actes.</li>
                    <li>Mòdul 6 · Llei orgànica 4/2015.</li>
                    <li>Mòdul 7 · Dret penal.</li>
                    <li>Mòdul 8 · Pràctiques completes.</li>
                    <li>Mòdul 9 · Procediments I.</li>
                    <li>Mòdul 10 · Procediments II.</li>
                    <li>Mòdul 11 · Normatives.</li>
                </ul>

                <p className="mt-5">
                    Aquesta estructura et permetrà treballar tant la base
                    jurídica com els procediments i les situacions pràctiques
                    que formen part de la preparació del Bulevard.
                </p>

                <h2 className={cn(styles.title, "mt-10")}>
                    <Emoji symbol="💻" label="acces campus practic" /> Accés al
                    campus
                </h2>

                <p className="mt-5">
                    Un cop formalitzada la matrícula, tindràs accés al campus
                    virtual les 24 hores del dia, els 7 dies de la setmana.
                </p>

                <p className="mt-5">
                    Podràs consultar els vídeos, revisar les fitxes i avançar al
                    teu ritme des de qualsevol lloc.
                </p>

                <p className="mt-5">
                    L&apos;accés estarà disponible fins al dia de la tirada de
                    gorra de la 40a promoció.
                </p>

                <h2 className={cn(styles.title, "mt-10")}>
                    <Emoji symbol="⚠️" label="condicions acces campus" />{" "}
                    Condicions d&apos;accés
                </h2>

                <p className="mt-5">
                    Els continguts i materials del campus són exclusius per als
                    alumnes matriculats.
                </p>

                <p className="mt-5">
                    No es permet la descàrrega, reproducció ni distribució dels
                    materials. Tot el contingut es podrà consultar online durant
                    tot el període d&apos;accés.
                </p>

                <h2 className={cn(styles.title, "mt-10")}>
                    <Emoji symbol="💰" label="preu campus practic" /> Preu
                </h2>

                <p className="mt-5">
                    <strong>119,99 €</strong>
                </p>

                <p className="mt-5">
                    Possibilitat de fraccionar el pagament sense interessos.
                </p>

                <h2 className={cn(styles.title, "mt-10")}>
                    <Emoji symbol="🔥" label="resum campus practic" /> En resum
                </h2>

                <p className="mt-5">
                    Un campus complet i pràctic perquè puguis preparar els
                    principals continguts del Bulevard abans d&apos;arribar a
                    l&apos;ISPC.
                </p>

                <p className="mt-5">
                    Vídeos, fitxes didàctiques, normativa, procediments i
                    pràctiques reunits en una única formació perquè puguis
                    arribar a la 40a promoció amb més coneixements i seguretat.
                </p>

                <p className="mt-5">
                    <Emoji symbol="👉" label="forma't com un professional" />{" "}
                    Forma&apos;t com un autèntic professional: tot el Bulevard,
                    concentrat en un sol campus.
                </p>
            </section>
        );
    };

    return (
        <NewProductTemplate
            item={item}
            title="Arriba a l'ISPC amb la confiança de qui ja sap què es trobarà."
        >
            <Data />
        </NewProductTemplate>
    );
};

export default Product;
